import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qe-id": "terms-modal" }

import { computed } from 'vue'
import { marked } from 'marked'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'TermsContentDefault',
  setup(__props) {

const { t } = useI18n()
const termsText = computed(() => {
  return marked(t('terms.main.terms'))
})

return (_ctx: any,_cache: any) => {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_modal_content = _resolveComponent("modal-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_modal_title, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('terms.main.title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_modal_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_t_text, {
          class: "terms-text",
          innerHTML: termsText.value
        }, null, 8, ["innerHTML"])
      ]),
      _: 1
    })
  ]))
}
}

})